import React, { FC } from "react";
import IConfirmModalProps from "./types";
import MainModal from "components/MainModal";
import { Box, Button, Typography } from "@mui/material";
import { useAppSelector } from "store/hooks/useAppSelector";
import { shallowEqual } from "react-redux";
import styles from "./ConfirmModal.styled";

const ConfirmModal: FC<IConfirmModalProps> = ({
  openModal,
  modalClose,
  handleAction,
  titleMessage,
  buttonMessage,
  secondBtnMessage,
  sx,
  isBlockModal,
}) => {
  const settings = useAppSelector(
    (state) => state.settings.config,
    shallowEqual,
  );

  const modalStyles = {
    ...styles,
    ...sx,
  };

  return (
    <MainModal isOpen={openModal} handleClose={modalClose} sx={styles.modal}>
      <Box sx={modalStyles.modalContent}>
        <Typography variant="h1" sx={styles.modalTitle}>
          {titleMessage}
        </Typography>
        <Box sx={modalStyles.modalButtonsContainer}>
          <Button
            onClick={isBlockModal ? handleAction : modalClose}
            sx={modalStyles.actionButton(settings.accentColor)}
            className="secondary"
          >
            {secondBtnMessage || "Скасувати"}
          </Button>
          <Button
            onClick={isBlockModal ? modalClose : handleAction}
            sx={modalStyles.actionButton(settings.accentColor)}
          >
            {buttonMessage}
          </Button>
        </Box>
      </Box>
    </MainModal>
  );
};

export default ConfirmModal;
